var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-data-table",
        {
          attrs: {
            headers: _vm.headers,
            loading: _vm.loading,
            items: _vm.hostingSshPrivateKeys
          },
          scopedSlots: _vm._u([
            {
              key: "item.actions",
              fn: function fn(_ref) {
                var item = _ref.item
                return [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        bottom: "",
                        "offset-y": "",
                        "min-width": "180"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function fn(_ref2) {
                              var on = _ref2.on,
                                attrs = _ref2.attrs
                              return [
                                _c(
                                  "gg-btn",
                                  _vm._g(
                                    _vm._b({}, "gg-btn", attrs, false),
                                    on
                                  ),
                                  [
                                    _vm._v(" Manage "),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          right: ""
                                        }
                                      },
                                      [_vm._v("mdi-chevron-down")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function click($event) {
                                  return _vm.openModal("view", item)
                                }
                              }
                            },
                            [
                              _c("v-list-item-title", [_vm._v("View/Download")])
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            {
                              on: {
                                click: function click($event) {
                                  return _vm.openModal("delete", item)
                                }
                              }
                            },
                            [_c("v-list-item-title", [_vm._v("Delete")])],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("v-progress-linear", {
            attrs: {
              slot: "progress",
              color: "green",
              height: "2",
              indeterminate: ""
            },
            slot: "progress"
          })
        ],
        1
      ),
      _vm.selectedSshKey
        ? _c("delete-ssh-key-modal", {
            attrs: {
              pub: "0",
              opened: _vm.modals.delete,
              "ssh-key": _vm.selectedSshKey
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("delete")
              },
              "key-deleted": _vm.reload
            }
          })
        : _vm._e(),
      _vm.selectedSshKey
        ? _c("view-ssh-key-modal", {
            attrs: {
              pub: "0",
              opened: _vm.modals.view,
              "ssh-key": _vm.selectedSshKey
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("view")
              }
            }
          })
        : _vm._e(),
      _vm.selectedSshKey
        ? _c("convert-to-ppk-modal", {
            attrs: {
              opened: _vm.modals.convert,
              "ssh-key": _vm.selectedSshKey
            },
            on: {
              close: function close($event) {
                return _vm.closeModal("convert")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }